const MATCH_CONTRIBUTE_CONFIG = {
  11394: {
    extraFields: [
      {
        key: "shoot_time",
        label: "拍摄时间",
        type: "input",
        defaultValue: "",
      },
      {
        key: "shoot_location",
        label: "拍摄地点",
        type: "input",
        defaultValue: "",
      },
      {
        key: "has_ai_assist",
        label: "是否含AI辅助、是否使用他人素材",
        type: "radio",
        defaultValue: 0,
        options: [
          { label: "否", value: 0 },
          { label: "是", value: 1 },
        ],
      },
    ],
    requirePromise: true,
    promiseText:
      "本人自愿参加本次摄影展赛，已认真阅读并完全知晓本次展赛全部征稿规则、参赛要求及相关说明。本人承诺所提交作品符合法律法规及赛事规定，若存在违反规则、侵犯他人著作权、肖像权等合法权益或弄虚作假等情形，自愿承担由此产生的全部法律责任及相应后果，与主办方、承办方无关。",
  },
};

export function getMatchContributeConfig(matchId) {
  const id = Number(matchId);
  if (!id || !MATCH_CONTRIBUTE_CONFIG[id]) {
    return null;
  }
  const config = MATCH_CONTRIBUTE_CONFIG[id];
  return {
    ...config,
    extraFields: (config.extraFields || []).map((field) => ({
      type: "input",
      required: false,
      options: [],
      ...field,
    })),
  };
}

export function applyExtraFieldsDefaults(customFields, config) {
  if (!customFields || !config || !config.extraFields) {
    return customFields;
  }
  config.extraFields.forEach((field) => {
    if (
      typeof customFields[field.key] === "undefined" ||
      customFields[field.key] === null
    ) {
      customFields[field.key] = field.defaultValue;
    }
  });
  return customFields;
}

export function buildExtraFieldsPayload(customFields, config) {
  if (!config || !config.extraFields) {
    return customFields;
  }
  const payload = Array.isArray(customFields)
    ? [...customFields]
    : { ...customFields };
  config.extraFields.forEach((field) => {
    let value = customFields[field.key];
    if (field.type === "checkbox" && typeof value === "boolean") {
      value = value ? 1 : 0;
    }
    payload[field.key] =
      typeof value === "undefined" ? field.defaultValue : value;
  });
  return payload;
}

